<div style="width: 290px; padding: 5px">
  <div class="row" style="margin: 0">
    <div class="col-md-12 form-group" style="padding: 5px 0 0">
      <div class="check">
        <input type="checkbox" id="checkboxA" name="SelectAll" [(ngModel)]="selectAll" />
        <label for="checkboxA"></label>
      </div>
      <label for="checkboxA">Select All</label>
    </div>
  </div>
  <div class="row" style="margin: 0">
    <div class="col-md-12 form-group" style="padding: 0">
      <select
        class="dropdownlist"
        [(ngModel)]="selectedItem"
        aria-placeholder="Select an item"
        [disabled]="selectAll"
      >
        <option
          *ngFor="let x of items"
          [innerHTML]="x.text"
          [value]="x.id"
          [disabled]="
            x.value &&
            ((x.value.IsActive !== undefined && !x.value.IsActive) ||
              (x.value.Enabled !== undefined && !x.value.Enabled))
          "
        ></option>
      </select>
    </div>
  </div>
</div>
